<template>
    <el-card>
        <el-row class="levelup__title">用户升级管理</el-row>
        <el-alert
            title="使用说明"
            type="info"
            :closable="false"
            show-icon>
            <div>1. 输入用户ID，多个ID用逗号分隔</div>
            <div>2. 选择等级类型和积分</div>
            <div>3. 点击"批量升级"进行批量操作</div>
        </el-alert>
        <!-- 搜索 -->
        <el-row class="levelup__search">
            <div class="item">
                <span>用户ID:</span>
                <el-input style="width: 300px;" v-model="searchList.userIds" placeholder="请输入用户ID，多个ID用逗号分隔" clearable></el-input>
            </div>
            <div class="item">
                <span>等级类型:</span>
                <el-select v-model="searchList.levelType" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in levelTypeList" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>积分:</span>
                <el-input style="width: 150px;" v-model="searchList.score" placeholder="请输入积分" clearable></el-input>
            </div>
            <el-button type="primary" @click="batchUpdateLevel" :loading="batchLoading">批量升级</el-button>
        </el-row>

    </el-card>
</template>
<script>
export default {
    name: 'LevelUp',
    data() {
        return {
            searchList: {
                userIds: '',
                levelType: null,
                score: null,
            },
            levelTypeList: [
                {
                    value: 3,
                    name: '用户等级'
                },
                {
                    value: 4,
                    name: '主播等级'
                }
            ],
            batchLoading: false,
        }
    },

    methods: {

        async batchUpdateLevel() {
            if (!this.searchList.userIds) {
                this.$message.warning('请输入用户ID')
                return
            }
            if (this.searchList.levelType === null || this.searchList.levelType === '') {
                this.$message.warning('请选择等级类型')
                return
            }
            if (!this.searchList.score || this.searchList.score <= 0) {
                this.$message.warning('请输入有效的积分')
                return
            }

            // 解析用户ID
            const userIds = this.searchList.userIds.split(',').map(id => id.trim()).filter(id => id)
            if (userIds.length === 0) {
                this.$message.warning('请输入有效的用户ID')
                return
            }

            this.$confirm(`确定要批量升级 ${userIds.length} 个用户吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                this.batchLoading = true
                try {
                    const { data: res } = await this.$axios({
                        method: 'post',
                        url: this.$store.getters.path.users_level_score_batch_update,
                        params: {
                            username: this.$store.getters.username,
                            token: this.$store.getters.token,
                        },
                        data: {
                            ridSet: userIds.map(id => parseInt(id)),
                            levelType: this.searchList.levelType,
                            score: parseInt(this.searchList.score)
                        }
                    })
                    if (res.code === 0 || res.status === 0) {
                        this.$message.success('批量升级成功')
                    } else {
                        this.$message.error(res.msg || res.message)
                    }
                } catch (error) {
                    this.$message.error('批量升级失败')
                    console.error('批量升级错误:', error)
                } finally {
                    this.batchLoading = false
                }
            }).catch(() => {
                this.$message.info('已取消批量升级')
            })
        },
    }
}
</script>
<style scoped lang="scss">
.levelup {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }
    }
}

.el-alert {
    margin-bottom: 20px;
}

.el-alert__content {
    div {
        margin-bottom: 5px;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style> 